import React, { Component } from 'react';
import './style.scss';
//import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Wrapper from '../../templates/Wrapper/Wrapper';
import FoodMenu from '../../containers/FoodMenu/FoodMenu';
import Helmet from 'react-helmet';
import { tl } from '../../shared/helpers';

import { tl_data } from './translations';

class OurMenu extends Component {
    

    render() {
        //console.log('our menu props ',this.props);
      ///^(breakfast|burgers|chicken|chubby-chicken|drinks|sides|kidspack|brewbar)$/
        return (
            <Wrapper addClass="our-menu" {...this.props}>
                
                    {this.props.match.params.category ? 
                        <Helmet>
                            <title>{tl(tl_data, `${this.props.match.params.category}_title`, this.props.lang)}</title>
                            <meta name="description" content={tl(tl_data, `${this.props.match.params.category}_description`, this.props.lang)} />
                            <link rel="canonical" href={`https://web.aw.ca/${this.props.lang}/our-menu/${this.props.match.params.category}`} />
                        </Helmet>
                        :
                        <Helmet>
                            <title>{tl(tl_data, 'breakfast_title', this.props.lang)}</title>
                            <meta name="description" content={tl(tl_data, "breakfast_description", this.props.lang)} />
                        </Helmet>                   
                    }

                <section>
                    {/* <FoodSelector caption="" initialCategory={category} slide={false} onLoad={this.loaded} onCategoryChange={this.categoryChange} /> */}
                    <FoodMenu {...this.props} ourMenuPage={true} />
                 
                </section>
            </Wrapper>
            
        );
    }
}

export default withRouter(OurMenu);

// Specifies the default values for props:
// OurMenu.defaultProps = {
//     initialCategory: 'breakfast'
// };
  